module.exports = __webpack_public_path__ + "img/edit.60ce4dec.svg";